var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { classNames } from '@progress/kendo-react-common';
/**
 * Returns the action bar of the Window.
 *
 * @returns React.ReactElement
 */
export var WindowActionsBar = function WindowActionsBar(props) {
  var combinedProps = __assign({
    layout: 'end'
  }, props);
  var layout = combinedProps.layout,
    children = combinedProps.children;
  var wrapperClasses = classNames('k-actions', 'k-window-actions', 'k-actions-horizontal', 'k-hstack', {
    'k-justify-content-start': layout === 'start',
    'k-justify-content-center': layout === 'center',
    'k-justify-content-end': layout === 'end',
    'k-justify-content-stretch': layout === 'stretched'
  });
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClasses
  }, children);
};